export const BUSINESS = {
  name: "Michael's Painting",
  tagline: "Transforming Spaces With Quality Painting Services",
  yearsExperience: "30+",
  projectsCompleted: "1.2K+",
  phone: "(608) 886-4598",
  phoneHref: "tel:6088864598",
  email: "michaelspainting0@gmail.com",
  address: "4012 Terminal Dr, McFarland, WI 53558",
  hours: "Mon–Sat · 8:00 AM – 6:30 PM",
  facebook: "https://www.facebook.com/p/michaels-painting-100064681102262/",
} as const;

export const SERVICE_AREAS = [
  "Madison", "Sun Prairie", "Middleton", "Fitchburg", "Verona", "Waunakee", "Stoughton",
] as const;

export const SERVICES = [
  { title: "Interior & Exterior Painting", desc: "Revitalize your home or business with flawless interior and exterior painting designed to last for years." },
  { title: "Cabinet Finishing", desc: "Upgrade your cabinets with refinishing or staining for a sleek, polished look that enhances your kitchen's appeal." },
  { title: "New Construction", desc: "Professional painting services for new homes, decks, and durable structures designed to last for years." },
  { title: "Drywall & Framing", desc: "Repair holes, cracks, or construct new framing with the utmost precision and care for lasting results." },
  { title: "Pressure Washing", desc: "Refresh exteriors, decks, and driveways with our thorough deep cleaning services for a stunning transformation." },
  { title: "Graffiti Removal", desc: "Quick and effective removal services to restore your property's clean and appealing look in no time." },
  { title: "Decks & Fences", desc: "Professional painting and staining for decks, fences, and exteriors that protect wood and enhance appeal." },
  { title: "Epoxy Flooring", desc: "Stylish epoxy floors designed for heavy use, enhancing your garage, basement, or commercial space." },
] as const;
